import Axios from "axios";
import { createExcelImportService } from "@/services/base/ExcelImportDataService";

class FuncionarioDataService {
  buscaCep(value) {
    return Axios.get(
      `http://cep.republicavirtual.com.br/web_cep.php?cep=${value}&formato=json`,
      {
        transformRequest: (data, headers) => {
          delete headers.common["Authorization"];
        },
      }
    );
  }

  getFuncionarioSindicatos() {
    return Axios.get("FuncionarioSindicatos");
  }

  getEstados() {
    return Axios.get("estados");
  }

  getCidades() {
    return Axios.get("cidades");
  }

  getPostoTrabalho() {
    return Axios.get("postosTrabalho");
  }

  getAll() {
    return Axios.get("funcionarios");
  }

  getPage(params) {
    return Axios.get("funcionarios/page", { params });
  }

  create(params) {
    return Axios.post("funcionarios", params);
  }

  createResume(params) {
    return Axios.post("funcionarios/resume", params);
  }

  update(params) {
    return Axios.put("funcionarios/" + params.id, params);
  }

  find(id) {
    return Axios.get(`funcionarios/${id}`);
  }

  // Histórico de salários (gravado a cada alteração do salário), do mais recente ao mais antigo.
  getSalarios(id) {
    return Axios.get(`funcionarios/${id}/salarios`);
  }

  enviarLembreteJornada(id, tipo) {
    return Axios.post(`funcionarios/${id}/lembreteJornada`, null, { params: { tipo } });
  }

  delete(id) {
    return Axios.delete(`funcionarios/${id}`);
  }

  getFilter(params) {
    return Axios.post("funcionarios/filter", params);
  }

  getFilterPage(payload, params) {
    return Axios.post("funcionarios/filter/page", payload, { params });
  }

  export(params) {
    return Axios.put("funcionarios/export", params);
  }

  getContratacoesPeriodo(params) {
    return Axios.post("funcionarios/contratacoesPeriodo", params);
  }

  getContratacoesPeriodoPdf(params) {
    return Axios.post("funcionarios/contratacoesPeriodo/pdf", params, {
      responseType: "blob",
    });
  }

  getContratacoesPeriodoExcel(params) {
    return Axios.post("funcionarios/contratacoesPeriodo/excel", params, {
      responseType: "blob",
    });
  }

  getDesligamentosPeriodo(params) {
    return Axios.post("funcionarios/desligamentosPeriodo", params);
  }

  getDesligamentosPeriodoPdf(params) {
    return Axios.post("funcionarios/desligamentosPeriodo/pdf", params, {
      responseType: "blob",
    });
  }

  getDesligamentosPeriodoExcel(params) {
    return Axios.post("funcionarios/desligamentosPeriodo/excel", params, {
      responseType: "blob",
    });
  }

  getIntegracaoExterna(params) {
    return Axios.post("funcionarios/integracaoExterna", params);
  }

  transferCompany(params) {
    return Axios.post("funcionarios/transferencia/empresa", params);
  }

  importDexion(params) {
    return Axios.post("funcionarios/import/dexion", params);
  }

  getUpdateImportFields() {
    return Axios.get("funcionarios/import/update/fields");
  }

  countUpdateImportEmployees(params) {
    return Axios.post("funcionarios/import/update/count", params);
  }

  getUpdateImportEmployees(payload, params) {
    return Axios.post("funcionarios/import/update/employees", payload, {
      params,
    });
  }

  generateUpdateImportTemplate(params) {
    return Axios.post("funcionarios/import/update/template", params, {
      responseType: "blob",
    });
  }

  validateUpdateImport(file) {
    const formData = new FormData();
    formData.append("file", file);
    return Axios.post("funcionarios/import/update/validate", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  applyUpdateImport(file) {
    const formData = new FormData();
    formData.append("file", file);
    return Axios.post("funcionarios/import/update/apply", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  getUniformes() {
    return Axios.get("produtos/ativos/tipoProduto/3");
  }

  getConvenios() {
    return Axios.get("beneficioConvenio/active");
  }
}

export default Object.assign(
  new FuncionarioDataService(),
  createExcelImportService("funcionarios")
);
